import {
  Component,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { Store } from '@ngrx/store';
import { getAllWindows } from '../window.selectors';

@Component({
  selector: 'dx-window-task-bar',
  templateUrl: './window-task-bar.component.html',
  styleUrls: ['./window-task-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WindowTaskBarComponent implements OnInit {

  public windows$ = this.store$.select(getAllWindows);

  public expand = false;

  constructor(public store$: Store<any>) { }

  ngOnInit() {
  }

}
